module.exports = __webpack_public_path__ + "static/media/Icon_external_link.6f693069.svg";